import { CustomReplace } from 'roosterjs-editor-plugins/lib/CustomReplace';
import type { CustomReplacement } from 'roosterjs-editor-types';

function makeEmojiReplacement(sourceString: string, replacementHTML: string): CustomReplacement {
    return {
        sourceString: sourceString,
        replacementHTML: replacementHTML,
        matchSourceCaseSensitive: true,
    };
}

// Used by CustomEdit, and handles autocomplete for emoji shortcuts beginning with a non-colon
// EmojiPickerPlugin handleEventExclusively when the inline emoji popup is shown
// and handles shortcut completion for all emoji which begin with a colon
const emojiReplacements: CustomReplacement[] = [
    makeEmojiReplacement(';)', '😉'),
    makeEmojiReplacement(';-)', '😉'),
    makeEmojiReplacement(';P', '😜'),
    makeEmojiReplacement(';-P', '😜'),
    makeEmojiReplacement('<3', '❤️'),
    makeEmojiReplacement('</3', '💔'),
    makeEmojiReplacement(';*', '😘'),
    makeEmojiReplacement(';-*', '😘'),
    makeEmojiReplacement('B)', '😎'),
    makeEmojiReplacement('B-)', '😎'),
];

export default class OwaCustomReplace extends CustomReplace {
    constructor() {
        super(emojiReplacements);
    }
}
